export default {
  baseUrl: 'https://sp.demoapi.v2.hyperthings.in/api/v1/',
};
